import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'toindoali_cart_v1';

const CartContext = createContext({
  items: [],
  addItem: () => {},
  removeItem: () => {},
  clearCart: () => {},
  count: 0,
  total: 0,
});

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);

  // Load from localStorage on mount
  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch {}
  }, []);

  // Persist to localStorage on change
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch {}
  }, [items]);

  const addItem = useCallback((item) => {
    const id = item.id || `${item.packageId}_${item.dateId}_${Date.now()}`;
    setItems(prev => {
      // Evita duplicar a mesma combinação pacote+data
      const dup = prev.find(p => p.packageId === item.packageId && p.dateId === item.dateId);
      if (dup) {
        return prev.map(p => p.id === dup.id ? { ...item, id: dup.id } : p);
      }
      return [...prev, { ...item, id, addedAt: new Date().toISOString() }];
    });
  }, []);

  const removeItem = useCallback((itemId) => {
    setItems(prev => prev.filter(p => p.id !== itemId));
  }, []);

  const clearCart = useCallback(() => setItems([]), []);

  const count = items.length;
  const total = items.reduce((sum, it) => sum + (Number(it.totalPrice) || 0), 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, clearCart, count, total }}>
      {children}
    </CartContext.Provider>
  );
};

export default CartContext;
